export const trainingCourseMixin = {
    data() {
        return {
            courseWithAutomation: [
                // 2, // removed dahil may sarili siyang update button --> anti piracy

                4,      // ballast water management (bwm) course
                5,      // basic maritime security awareness (isps code)
                6,      // basic navigation (for deck rating)
                11,     // situation & risk assessment for safety navigation
                23,     // familiarization training in mooring equipment (ftme)
                28,     // hair cutting training
                34,     // ism code / stcw convention
                38,     // ism / safety management system evaluation
                46,     // promotion/upgrading management level - deck
                47,     // promotion/upgrading management level - engine
                54,     // promotion/upgrading operational level - deck
                55,     // promotion/upgrading operational level - engine
                58,     // pcc damage prevention
                63,     // s.o.t. english training
                78,     // promotion/upgrading support level - deck
                79,     // promotion/upgrading support level - engine
                94,     // maritime english - marlins
                95,     // promotion/upgrading steward course - chief cook
                96,     // promotion/upgrading steward course - second cook
                97,     // promotion/upgrading steward course - messman
                98,     // ism / safety management system evaluation - deck
                99,     // ism / safety management system evaluation - engine
                100,    // ism / safety management system evaluation - steward
                101,    // ism / safety management system - deck
                102,    // ism / safety management system - engine
                103,    // ism / safety management system - steward
                105,    // proficiency in survival craft and rescue boats
                113,    // safety management system seminar
                // 114,    // pcc promotion
                // 115,    // bulk promotion certificate
                124,    // safe practices and handling of fumigated cargo

    ]
        }
    }
}